import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import {
  NgxCroppedEvent,
  PhotoEditorService,
} from '@perval/cropperjs-picture-editor';

@Component({
  selector: 'p-photo-editor',
  templateUrl: './p-photo-editor.component.html',
  styleUrls: ['./p-photo-editor.component.scss'],
})
export class PPhotoEditorComponent implements OnChanges {
  @Input() photo!: string | undefined;
  @Input() label = 'Charger une photo';
  @Input() isSmall = false;
  @Output() croppedImage = new EventEmitter<string | undefined>();
  @Output() clearPhoto = new EventEmitter();
  internalPhoto!: string | undefined;
  internalId = this.getInputId();
  private previousInputPhoto: string | undefined;
  constructor(
    private service: PhotoEditorService,
    private ngZone: NgZone,
  ) {}
  getInputId(): string {
    return Math.random().toString(36).substring(2);
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['photo']) {
      this.internalPhoto = changes['photo'].currentValue;
      this.previousInputPhoto = this.internalPhoto;
    }
  }
  fileChangeHandler($event: Event) {
    const input = $event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.service
        .open(file, {
          aspectRatio: 4 / 3,
          autoCropArea: 1,
          modalTitle: 'Editeur de photo',
          applyBtnText: 'Appliquer',
          closeBtnText: 'Fermer',
        })
        .subscribe((data: NgxCroppedEvent) => {
          const dimensions = this.isSmall
            ? { width: 300, height: 300 }
            : { width: 640, height: 480 };
          this.resizeImage(data.base64 as string, dimensions).then(
            (resizedImage) => {
              this.ngZone.run(() => {
                this.previousInputPhoto = this.internalPhoto;
                this.internalPhoto = resizedImage;
                this.croppedImage.emit(this.internalPhoto);
              });
            },
          );
        });
      input.value = '';
    }
  }
  changePhoto() {
    document.getElementById(this.internalId)?.click();
  }
  removePhoto() {
    this.internalPhoto = undefined;
    this.clearPhoto.emit();
  }
  private resizeImage(
    base64Image: string,
    {
      width: targetWidth,
      height: targetHeight,
    }: { width: number; height: number },
  ): Promise<string> {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        const aspectRatio = img.width / img.height;
        let width = targetWidth;
        let height = targetHeight;
        if (img.width / img.height > targetWidth / targetHeight) {
          height = targetWidth / aspectRatio;
        } else {
          width = targetHeight * aspectRatio;
        }
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        if (ctx) {
          ctx.drawImage(img, 0, 0, width, height);
          resolve(canvas.toDataURL('image/jpeg', 1.0));
        }
      };
      img.src = base64Image;
    });
  }
}
